/* Organique Kuwait – storefront behaviour (no dependencies) */
(function () {
  'use strict';
  var d = document;
  var html = d.documentElement;
  var isAR = (html.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
  var T = window.OrgT || {};
  function store(kind) {
    return {
      get: function (k) { try { return window[kind].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window[kind].setItem(k, v); } catch (e) {} }
    };
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');
  SS.set('org_pv', String(Number(SS.get('org_pv') || 0) + 1));
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* ---------- Currency label: "KD" in English, "د.ك" in Arabic, never doubled ---------- */
  var RE_DOUBLE = new RegExp('\\bKD\\s+KWD\\b', 'g');
  var RE_KWD = new RegExp('\\bKWD\\b', 'g');
  var RE_KD = new RegExp('\\bKD\\b', 'g');
  function fixText(t) {
    var v = t.nodeValue;
    if (!v || (v.indexOf('KD') === -1 && v.indexOf('KWD') === -1)) return;
    var n = v.replace(RE_DOUBLE, 'KD').replace(RE_KWD, 'KD');
    if (isAR) n = n.replace(RE_KD, 'د.ك');
    if (n !== v) t.nodeValue = n;
  }
  function skip(node) {
    var p = node.parentNode;
    return !p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE' || p.nodeName === 'TEXTAREA';
  }
  function fixMoney(root) {
    if (!root) return;
    if (root.nodeType === 3) { if (!skip(root)) fixText(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (root.nodeName === 'SCRIPT' || root.nodeName === 'STYLE') return;
    var w = d.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    for (var i = 0; i < list.length; i++) if (!skip(list[i])) fixText(list[i]);
  }
  fixMoney(d.body);
  if ('MutationObserver' in window) {
    var pending = [];
    var scheduled = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') pending.push(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) pending.push(m.addedNodes[j]);
      }
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        var list = pending; pending = [];
        for (var k = 0; k < list.length; k++) { fixMoney(list[k]); fillEta(list[k]); }
      });
    }).observe(d.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Quick add to cart (uses the theme's cart drawer) ---------- */
  function cartAdd(variantId, qty, btn) {
    var label = btn ? btn.querySelector('[data-org-label]') : null;
    var original = label ? label.textContent : '';
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (label && T.adding) label.textContent = T.adding;
    }
    function finish(ok) {
      if (!btn) return;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (label) label.textContent = ok ? (T.added || original) : (T.error || original);
      if (ok) btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2200);
    }
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      actions.updateCart(
        { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: qty }] },
        { event: { context: 'product' } }
      ).then(function (res) {
        var bad = res && res.userErrors && res.userErrors.length;
        finish(!bad);
        if (bad) return;
        setTimeout(function () {
          var drawer = d.querySelector('theme-drawer#cart-drawer');
          if (drawer && !drawer.hasAttribute('open') && typeof actions.openCart === 'function') actions.openCart();
        }, 400);
      }).catch(function () { fallbackAdd(variantId, qty, finish); });
    } else {
      fallbackAdd(variantId, qty, finish);
    }
  }
  function fallbackAdd(variantId, qty, finish) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function () {
      finish(true);
      window.location.href = root + 'cart';
    }).catch(function () { finish(false); });
  }

  /* ---------- Delegated clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var add = closest(t, '[data-org-add]');
    if (add) {
      e.preventDefault();
      if (!add.disabled && !add.classList.contains('is-loading')) cartAdd(add.getAttribute('data-org-add'), 1, add);
      return;
    }
    var play = closest(t, '[data-org-play]');
    if (play) { playVideo(closest(play, '.org-ugc__item')); return; }
    var playing = closest(t, '.org-ugc__item.is-playing video');
    if (playing) { stopVideo(closest(playing, '.org-ugc__item')); return; }
    var tab = closest(t, '.org-tabs__tab');
    if (tab) { selectTab(tab); return; }
    var acc = closest(t, '.org-acc__btn');
    if (acc) {
      var accPanel = d.getElementById(acc.getAttribute('aria-controls'));
      var accOpen = acc.getAttribute('aria-expanded') !== 'true';
      acc.setAttribute('aria-expanded', accOpen ? 'true' : 'false');
      if (accPanel) accPanel.hidden = !accOpen;
      return;
    }
    var copy = closest(t, '[data-org-copy]');
    if (copy) { copyCode(copy); return; }
    var opener = closest(t, '[data-org-sheet]');
    if (opener) {
      var sheet = d.getElementById(opener.getAttribute('data-org-sheet'));
      if (sheet && typeof sheet.showModal === 'function') sheet.showModal();
      return;
    }
    var closer = closest(t, '[data-org-sheet-close]');
    if (closer) { var dl = closest(closer, 'dialog'); if (dl) dl.close(); return; }
    var sort = closest(t, '[data-org-sort]');
    if (sort) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.getAttribute('data-org-sort'));
      u.searchParams.delete('page');
      window.location.href = u.toString();
      return;
    }
    var setlang = closest(t, '[data-org-setlang]');
    if (setlang) LS.set('org_lang_choice', setlang.getAttribute('data-org-setlang'));
  });

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    if (!root || root.__org) return;
    root.__org = true;
    var track = root.querySelector('.org-hero__track');
    var slides = track ? track.children : [];
    var dots = root.querySelectorAll('.org-hero__dot');
    if (!track || slides.length < 2) return;
    var index = 0, timer = null, inView = true, paused = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setDot(i) {
      index = i;
      each(dots, function (dot, k) { dot.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setDot(i);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (paused || !inView || reduce) return;
      timer = setInterval(function () { if (!d.hidden) go(index + 1); }, 5500);
    }
    each(dots, function (dot, k) { dot.addEventListener('click', function () { paused = true; stop(); go(k); }); });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { paused = true; stop(); }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start(); else stop();
      }).observe(root);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var i = Array.prototype.indexOf.call(slides, en.target);
            if (i > -1) setDot(i);
          }
        });
      }, { root: track, threshold: 0.6 });
      each(slides, function (s) { io.observe(s); });
    }
    start();
  }

  /* ---------- Announcement bar rotation (phones) ---------- */
  function initAnnounce(root) {
    if (!root || root.__org) return;
    root.__org = true;
    var items = root.querySelectorAll('.org-announce__item');
    if (items.length < 2) return;
    var i = 0;
    var wide = window.matchMedia('(min-width: 990px)');
    setInterval(function () {
      if (wide.matches || d.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- UGC videos: tap to play, one at a time ---------- */
  function playVideo(item) {
    if (!item) return;
    var v = item.querySelector('video');
    if (!v) return;
    each(d.querySelectorAll('.org-ugc__item.is-playing'), function (o) { if (o !== item) stopVideo(o); });
    item.classList.add('is-playing');
    v.muted = false;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
  }
  function stopVideo(item) {
    if (!item) return;
    var v = item.querySelector('video');
    if (v) v.pause();
    item.classList.remove('is-playing');
  }
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (!en.isIntersecting) stopVideo(closest(en.target, '.org-ugc__item.is-playing')); });
    }, { threshold: 0.2 });
    each(d.querySelectorAll('.org-ugc__item video'), function (v) { vio.observe(v); });
  }

  /* ---------- Product tabs ---------- */
  function selectTab(tab) {
    var root = closest(tab, '.org-tabs');
    if (!root) return;
    each(root.querySelectorAll('.org-tabs__tab'), function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = d.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
      var accBtn = root.querySelector('.org-acc__btn[aria-controls="' + t.getAttribute('aria-controls') + '"]');
      if (accBtn) accBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  d.addEventListener('keydown', function (e) {
    var tab = closest(e.target, '.org-tabs__tab');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(closest(tab, '.org-tabs__list').querySelectorAll('.org-tabs__tab'));
    var i = tabs.indexOf(tab);
    var rtl = html.dir === 'rtl';
    var step = { ArrowRight: rtl ? -1 : 1, ArrowLeft: rtl ? 1 : -1 }[e.key];
    var target = null;
    if (step) target = tabs[(i + step + tabs.length) % tabs.length];
    if (e.key === 'Home') target = tabs[0];
    if (e.key === 'End') target = tabs[tabs.length - 1];
    if (target) { e.preventDefault(); selectTab(target); target.focus(); }
  });

  /* ---------- Copy discount code ---------- */
  function copyCode(btn) {
    var code = btn.getAttribute('data-org-copy');
    var original = btn.textContent;
    var done = function () {
      btn.textContent = T.copied || original;
      setTimeout(function () { btn.textContent = original; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var ta = d.createElement('textarea');
      ta.value = code;
      d.body.appendChild(ta);
      ta.select();
      try { d.execCommand('copy'); } catch (x) {}
      ta.remove();
      done();
    }
  }

  /* ---------- Keep preview/query parameters on language links ---------- */
  function keepQuery(a) {
    var q = window.location.search;
    var href = a.getAttribute('href');
    if (!q || !href || href.indexOf('?') > -1) return;
    a.setAttribute('href', href + q);
  }
  each(d.querySelectorAll('[data-org-setlang], [data-org-lang="ar"]'), keepQuery);

  /* ---------- Arabic suggestion for Arabic phones (one tap) ---------- */
  var langbar = d.getElementById('OrgLangbar');
  var langbarOpen = false;
  function openLangbar() {
    if (d.querySelector('details.menu-open, dialog[open], theme-drawer[open]')) { setTimeout(openLangbar, 3000); return; }
    langbar.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { langbar.classList.add('is-visible'); }); });
    d.body.classList.add('org-langbar-open');
  }
  function closeLangbar() {
    langbar.classList.remove('is-visible');
    d.body.classList.remove('org-langbar-open');
    langbarOpen = false;
    setTimeout(function () { langbar.hidden = true; }, 400);
    d.dispatchEvent(new CustomEvent('org:langbar-closed'));
  }
  if (langbar && !isAR) {
    var langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']).join(',').toLowerCase();
    var force = window.location.search.indexOf('org_langbar=1') > -1;
    var arabicPhone = langs.split(',').some(function (l) { l = l.trim(); return l === 'ar' || l.indexOf('ar-') === 0; });
    if (force || (!LS.get('org_lang_choice') && arabicPhone)) {
      langbarOpen = true;
      setTimeout(openLangbar, force ? 300 : 1500);
    }
    langbar.addEventListener('click', function (e) {
      var b = closest(e.target, '[data-org-lang]');
      if (!b) return;
      var lang = b.getAttribute('data-org-lang');
      LS.set('org_lang_choice', lang);
      if (lang !== 'ar') { e.preventDefault(); closeLangbar(); }
    });
  }

  /* ---------- Delivery date (Kuwait): "Order by midnight – delivered tomorrow, Monday 28 September" ----------
     Orders placed by midnight are delivered the next day (the warehouse starts at 8 am). Between midnight
     and 8 am the line says "Delivered within 24 hours". No countdown, just the date. */
  var etaText = null;
  function computeEta() {
    if (etaText !== null) return etaText;
    etaText = '';
    var now = new Date();
    var hour;
    try {
      hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kuwait', hour: '2-digit', hourCycle: 'h23' }).format(now));
    } catch (x) { hour = (now.getUTCHours() + 3) % 24; }
    if (hour < 8) { etaText = T.eta24 || ''; return etaText; }
    var ds = '';
    try {
      ds = new Intl.DateTimeFormat(isAR ? 'ar-KW-u-nu-latn' : 'en-GB', { timeZone: 'Asia/Kuwait', weekday: 'long', day: 'numeric', month: 'long' }).format(new Date(now.getTime() + 864e5));
    } catch (x) { ds = ''; }
    etaText = ds && T.etaTomorrow ? T.etaTomorrow.replace('[date]', ds) : (T.eta24 || '');
    return etaText;
  }
  function fillEta(root) {
    if (!root || root.nodeType !== 1) return;
    var list = root.matches && root.matches('[data-org-eta]') ? [root] : root.querySelectorAll('[data-org-eta]');
    if (!list.length) return;
    var txt = computeEta();
    if (!txt) return;
    each(list, function (el) { if (el.textContent !== txt) el.textContent = txt; el.hidden = false; });
  }
  fillEta(d.body);

  /* ---------- Welcome offer pop-up ----------
     Never on product, cart or search pages; from the 2nd page view of a visit, or after scrolling half a page.
     Never together with the language bar, a drawer or another dialog. Closed = quiet for 14 days. */
  var modal = d.getElementById('OrgWelcome');
  function openModal() {
    if (!modal || modal.open) return;
    if (typeof modal.showModal === 'function') {
      try { modal.showModal(); } catch (x) { modal.setAttribute('open', ''); }
    } else modal.setAttribute('open', '');
  }
  function closeModal() {
    LS.set('org_welcome', 'closed:' + Date.now());
    if (typeof modal.close === 'function' && modal.open) modal.close(); else modal.removeAttribute('open');
  }
  function busy() {
    return !!d.querySelector('dialog[open]:not(#OrgWelcome), theme-drawer[open]');
  }
  function tryOpen() {
    if (langbarOpen) {
      d.addEventListener('org:langbar-closed', function () { setTimeout(tryOpen, 5000); }, { once: true });
      return;
    }
    if (busy()) { setTimeout(tryOpen, 6000); return; }
    openModal();
  }
  if (d.querySelector('[data-org-subscribed]')) LS.set('org_welcome', 'subscribed');
  if (modal) {
    var state = LS.get('org_welcome') || '';
    var fromPopup = SS.get('org_welcome_submit') === '1';
    if (fromPopup) SS.set('org_welcome_submit', '');
    if (fromPopup && window.location.search.indexOf('customer_posted=true') > -1) {
      openModal();
    } else if (window.location.search.indexOf('org_popup=1') > -1) {
      setTimeout(openModal, 500);
    } else if (state !== 'subscribed' && !(state.indexOf('closed:') === 0 && Date.now() - Number(state.split(':')[1]) < 14 * 864e5)) {
      var pageViews = Number(SS.get('org_pv') || 0);
      var blockedPage = /\borg-tpl-(product|cart|search)\b/.test(d.body.className);
      if (!blockedPage) {
        if (pageViews >= 2) {
          setTimeout(tryOpen, 6000);
        } else {
          var onScroll = function () {
            var max = d.documentElement.scrollHeight - window.innerHeight;
            if (max > 200 && window.scrollY / max >= 0.5) {
              window.removeEventListener('scroll', onScroll);
              setTimeout(tryOpen, 800);
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
        }
      }
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal || closest(e.target, '[data-org-close]')) closeModal();
    });
    modal.addEventListener('cancel', function () { LS.set('org_welcome', 'closed:' + Date.now()); });
    var form = modal.querySelector('form');
    if (form) form.addEventListener('submit', function () { SS.set('org_welcome_submit', '1'); });
  }

  /* ---------- Collection sheets: close on backdrop, keep extra query params ---------- */
  each(d.querySelectorAll('dialog.org-sheet'), function (dl) {
    dl.addEventListener('click', function (e) { if (e.target === dl) dl.close(); });
  });
  each(d.querySelectorAll('form[data-org-filters]'), function (f) {
    f.addEventListener('submit', function () {
      var cur = new URLSearchParams(window.location.search);
      cur.forEach(function (v, k) {
        if (k.indexOf('filter.') === 0 || k === 'page' || f.elements[k]) return;
        var i = d.createElement('input');
        i.type = 'hidden'; i.name = k; i.value = v;
        f.appendChild(i);
      });
      each(f.querySelectorAll('input[type="number"]'), function (inp) { if (inp.value === '') inp.disabled = true; });
    });
  });

  /* ---------- Lazy "You may also like" ---------- */
  each(d.querySelectorAll('[data-org-reco]'), function (el) {
    var load = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (txt) {
        var tmp = d.createElement('div');
        tmp.innerHTML = txt;
        var res = tmp.querySelector('[data-org-reco-result]');
        if (res && res.querySelector('.org-card')) el.replaceWith(res); else el.remove();
      }).catch(function () { el.remove(); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Init + theme editor support ---------- */
  function init(scope) {
    each((scope || d).querySelectorAll('[data-org-hero]'), initHero);
    each((scope || d).querySelectorAll('[data-org-announce]'), initAnnounce);
  }
  init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); fixMoney(e.target); });
})();